<template>
  <div id="app">
    <Sidebar/>
    <Header/>
    <transition appear>
      <router-view/>
    </transition>
    <Footer/>
  </div>
</template>

<script>
import Sidebar from './components/common/Sidebar'
import Footer from './components/common/Footer'
import Header from './components/common/Header'
// import Loading from './components/Loading'
export default {
  name: 'App',
  components : {
    Sidebar,
    Footer,
    Header,
    // Loading
  }
}
</script>

<style>
@import "https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.5.2/animate.css";
html {
  height: 100%;
}

body {
  height: 100%;
  width: 100%;
  margin: 0;
}

.v-enter-active {
  will-change: opacity;
  transition: opacity .5s cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}
.v-enter {
  opacity: 0;
}

@media screen and (min-width:1024px) {
  #app {
    padding-left: 15em;
  }
}

#app {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-family: 'UD Shin Go Medium' !important;
}

p.title_red {
  color: #b55746;
  font-size: 12px;
  font-weight: bold;
  text-align: left;
}

.subtitle {
  font-size: 12px;
  color: #333;
  font-weight: bold;
}
.content {
  color: #333;
  font-size: 14px;
  line-height: 1.7;
  text-align: left;
}

h2.title {
  font-size: 40px;
  color: #b55746;
  margin: 8px 0 24px;
}

h2.title_recruit {
  font-size: 26px;
  color: #b55746;
  margin: 8px 0 24px;
}

.subtitle_white {
  font-size: 12px;
  color: #fff;
  font-weight: bold;
}

.content_white {
  color: #fff;
  font-size: 14px;
  line-height: 1.7;
  text-align: left;
}

h2.title_white {
  font-size: 26ßpx;
  color: #fff;
  margin: 8px 0 24px;
}

p.content {
  font-size: 14px;
  color: #555;
  line-height: 1.7;
}
</style>



// WEBPACK FOOTER //
// src/App.vue